import { text } from '@modules/sowing-calendar/text';
import type { AgendaSectionId, SowMethod, SowingCalendarStatus } from './models';

export const textBusinessLogic = {
  sectionTitle(id: AgendaSectionId, detail?: string): string {
    const base = (() => {
      switch (id) {
        case 'due-now':
          return text.sectionDueNow;
        case 'upcoming':
          return text.sectionUpcoming;
        case 'out-of-season':
          return text.sectionOutOfSeason;
        case 'sown':
          return text.sectionSown;
      }
    })();
    return detail ? text.sectionWithDetail(base, detail) : base;
  },

  statusTag(status: SowingCalendarStatus, sowMethod: SowMethod): string | null {
    switch (status) {
      case 'due-now':
        return sowMethod === 'outdoor' ? text.statusSowOutdoors : text.statusStartIndoors;
      case 'upcoming':
        return null;
      case 'sown':
        return text.statusGrowing;
      case 'out-of-season':
        return text.statusOutOfSeason;
    }
  },

  entrySubtext(args: {
    status: SowingCalendarStatus;
    sowMethod: SowMethod;
    windowLabel: string;
  }): string {
    const { status, sowMethod, windowLabel } = args;
    switch (status) {
      case 'due-now':
      case 'upcoming':
        return sowMethod === 'outdoor'
          ? text.outdoorSubtext(windowLabel)
          : text.indoorSubtext(windowLabel);
      case 'sown':
        return text.sownSubtext;
      case 'out-of-season':
        return text.outOfSeasonSubtext(windowLabel);
    }
  },

  isSectionAccent(id: AgendaSectionId): boolean {
    return id === 'due-now';
  },

  timeBucketLabel(args: {
    status: SowingCalendarStatus;
    pinDate: string | null;
    windowLabel: string;
    formatPinDate: (isoDate: string) => string;
  }): string {
    const { status, pinDate, windowLabel, formatPinDate } = args;
    switch (status) {
      case 'due-now':
        return text.timeBucketDueNow;
      case 'upcoming':
        return pinDate ? text.timeBucketStarting(formatPinDate(pinDate)) : text.timeBucketLater;
      case 'sown':
        return text.timeBucketSown;
      case 'out-of-season':
        return windowLabel
          ? text.timeBucketStarting(windowLabel.split(' – ')[0])
          : text.timeBucketLater;
    }
  },
};
